
import React from 'react'
export const Banner: React.FC<{tone?: 'info'|'success'|'warn'|'error'; message: string; action?: React.ReactNode}> = ({tone='info', message, action}) => {
  const toneMap = { info:'bg-blue-50 border-blue-300 text-blue-900', success:'bg-green-50 border-green-300 text-green-900', warn:'bg-yellow-50 border-yellow-300 text-yellow-900', error:'bg-red-50 border-red-300 text-red-900' }
  return <div className={`border p-3 rounded-xl flex items-center justify-between ${toneMap[tone]}`}><span>{message}</span>{action}</div>
}
